import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/api/QuotesApi" );

export const loadQuotes = ( showConverted ) => instance.get( "LoadQuotes", { showConverted } );

export const convertToBasket = ( quoteId ) => instance.post( "ConvertToBasket", null, { quoteId } );
